module.exports = __webpack_public_path__ + "static/media/cga_logo_actual_size.e055be8d.svg";